export function timeToMovement(time: number) {
  return Math.cos(time) + 1;
}
